export const theme = {
  colors: {
    primary: "teal",
    secondary: "green",
    background: "#F0F0F0",
    segment: "#ffffff",
    text: "#333",
    buttonText: "#fff",
    buttonSubmitActive: "hsl(180, 100%, 35%)",
    buttonSubmitHover: "hsl(180, 100%, 30%)",
    buttonDisabled: "#bfbfbf",
    buttonCompletedHover: "hsl(120, 100%, 30%)",
    buttonCompletedActive: "hsl(120, 100%, 35%)",
    ButtonRemove: "rgb(250, 48, 48)",
    ButtonRemoveHover: "hsl(0, 100%, 65%)",
    ButtonRemoveActive: "hsl(0, 100%, 75%)",
    NavTextColor: "white",
  },
  breakpoints: {
    mobile: 767,
  },
};
